import { fetchPortalCurrencies } from './multiCurrencyApi';
import { makeMultiCurrencyFetchKey } from 'framework-data-schema-quick-fetch';
import { Metrics } from '../metrics';
import { wrapPromise } from 'persist-promise/wrapPromise';
import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
const multiCurrencyPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'multiCurrency',
  deepFreeze: true,
  toCacheKey: makeMultiCurrencyFetchKey,
  fetch: fetchPortalCurrencies,
  metricsConfig: {
    enablePatchDiffing: false
  }
});
export const makeMultiCurrencyClient = ({
  httpClient,
  persistedPromise = multiCurrencyPersistedPromise
}) => {
  return Promise.resolve({
    /**
     * Prints debug info to the console.
     */
    debug: () => {
      persistedPromise.debug();
    },
    /**
     * Clears internal cache state
     *
     * @returns A promise which resolves when state is clear.
     */
    clearCache: () => {
      persistedPromise.clearCache();
      return Promise.resolve();
    },
    /**
     * Gets all currency information for the portal, including home currency
     * and exchange rates.
     *
     * @param options.__isComposed For internal metrics tracking purposes only. Set to true when called within another client method.
     * @returns A promise which resolves to the portal's currency information, or null if the data could not be found.
     */
    get: ({
      __isComposed = false
    } = {}) => {
      if (!__isComposed) {
        Metrics.counter('multiCurrency.get').increment();
      }
      return persistedPromise.makeFetchWithOpts({
        allowEagerCacheReturn: isEarlyCacheReturnEnabled()
      })({
        httpClient
      });
    }
  });
};